export default {"src":"/_next/static/media/4-forbes-logo.ab5f0d87.svg","height":22,"width":78};